import { getCommunicationCount } from '@/actions/pages/app/protected-routes';
import { React, Sidebar, useEffect, useNavbarStatus, useState, useRouter} from '@/imports-files/common/common';
import PageStyle from '@/styles/pages/clients/dashboard/_index.module.scss';
import cloneDeep from 'lodash.clonedeep';


export default function ClientDashboard(props)
{
    const router                                =   useRouter();
    const { navbarStatus, updateNavbarStatus }  =   useNavbarStatus();
    var [path, setPath]                         =   useState(router.asPath);
    const [pagekey, setPageKey]                 =   useState('');
    const [isLoading, setLoading]               =   useState(true);
    const [countCommunication, setCountCommunication] = useState(0);
    // props.children.props.setCountCommunication = setCountCommunication;
    let copy_props                              =  process.env.NODE_ENV == "development" ? props : cloneDeep(props)
    if(process.env.NODE_ENV == "production") { copy_props.children.props['setCountCommunication'] = setCountCommunication; }
    useEffect( async() => {
                        if( typeof navbarStatus != "undefined")
                        {
                            let pathname = router.pathname;
                            var navbarStatusChangeVal  =  JSON.parse(localStorage.getItem('navbarStatus'));
                            setPageKey(navbarStatusChangeVal.key);
                            // ( props.children.props.session && pathname.startsWith("/clients/dashboard/")) ? await getCommunicationCount(setCountCommunication) : '';
                            setLoading(false);
                        }
                    })

    // useEffect( () => {
    //                         let pathname = router.pathname;
    //                         ( props.children.props.session && pathname.startsWith("/clients/dashboard/")) ? getCommunicationCount(setCountCommunication) : '';
    //                 },[router.pathname])

    if(isLoading)
    {
        return null;
    }

    return(
                <div className="Page Dashboard">

                    <Sidebar navbarStatus           =   {navbarStatus}
                             updateNavbarStatus     =   {updateNavbarStatus}
                             pagekey                =   {pagekey}
                             setPageKey             =   {setPageKey}
                             setPath                =   {setPath}
                             path                   =   {path}
                             session                =   {copy_props.children.props.session}
                             countCommunication     =   {countCommunication||0}
                    />

                        <div className = {`DashboardPage ${PageStyle.DashboardPage}`}>

                            <div className="main-content">
                                {/*<div className={`toggleButton`}>
                                    <button><span>Toggle</span></button>
                                </div>*/}
                                    {copy_props.children}

                            </div>

                            <div className={`${PageStyle.DashboardPage__TopRightCurveSection} noprint`}>
                                <div className={`TopRightCurve ${PageStyle.DashboardPage__TopRightCurve}`}></div>
                            </div>

                            <div className={`${PageStyle.DashboardPage__BottomRightCurveSection} noprint`}>
                                <div className={`BottomRightCurve ${PageStyle.DashboardPage__BottomRightCurve}`}></div>
                            </div>
                        </div>


                </div>
          )
}
